module.exports = __webpack_public_path__ + "static/media/logo.cc25d7fe.png";